/*
 * CASA BELLA size guide (snippets/cb-size-assistant.liquid): builds the measurement table and the
 * garment drawing from the product's size guide metafield, and opens it in a dialog.
 */
(function () {
  if (window.CBSizeGuide) return;

  var LENGTH_KEYS = ['COMPRIMENTO', 'LENGTH', 'LARGO', 'LONGUEUR'];
  var CHEST_NAMES = /^(cava|axila|peito|busto|largura|chest|bust|pit)/i;

  function norm(value) {
    return String(value == null ? '' : value).trim().toUpperCase();
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Find a key of an object regardless of letter case.
  function lookup(map, size) {
    if (!map) return null;
    var wanted = norm(size);
    for (var key in map) {
      if (Object.prototype.hasOwnProperty.call(map, key) && norm(key) === wanted) return map[key];
    }
    return null;
  }

  function cell(value) {
    if (Array.isArray(value) && value.length === 2) return escapeHtml(value[0]) + '–' + escapeHtml(value[1]);
    return value == null || value === '' ? '—' : escapeHtml(value);
  }

  // Line drawing of a coat with the measured lines: A underarm to underarm, B shoulder to hem.
  function figure(showChest, showLength) {
    var svg = '<figure class="cb-size__figure" aria-hidden="true"><svg viewBox="0 0 132 152" fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round" stroke-linecap="round">';
    svg += '<path d="M44 10 L62 18 L80 10 L96 16 L110 72 L100 75 L90 44 L90 142 L34 142 L34 44 L24 75 L14 72 L28 16 Z"/>';
    svg += '<path d="M44 10 L54 42 L62 18 L70 42 L80 10" /><path d="M62 42 V142" opacity=".5"/>';
    svg += '<circle cx="57" cy="66" r="1.4"/><circle cx="57" cy="88" r="1.4"/>';
    if (showChest) {
      svg += '<path class="cb-size__figure-line" d="M35 50 H89 M35 46 V54 M89 46 V54"/>';
      svg += '<circle class="cb-size__figure-dot" cx="62" cy="50" r="6.5"/><text x="62" y="53.2" text-anchor="middle">A</text>';
    }
    if (showLength) {
      svg += '<path class="cb-size__figure-line" d="M120 13 V142 M116 13 H124 M116 142 H124"/>';
      svg += '<circle class="cb-size__figure-dot" cx="120" cy="78" r="6.5"/><text x="120" y="81.2" text-anchor="middle">B</text>';
    }
    return svg + '</svg></figure>';
  }

  // Column names come from the product's size guide (written in Portuguese): shown in the shopper's language
  var LANG = (document.documentElement.lang || 'pt').slice(0, 2);
  var NAMES = {
    cava: { pt: 'Cava', en: 'Chest width', es: 'Ancho de pecho', fr: 'Largeur poitrine' },
    comprimento: { pt: 'Comprimento', en: 'Length', es: 'Largo', fr: 'Longueur' },
    manga: { pt: 'Manga', en: 'Sleeve', es: 'Manga', fr: 'Manche' },
    ombros: { pt: 'Ombros', en: 'Shoulders', es: 'Hombros', fr: 'Épaules' },
    cintura: { pt: 'Cintura', en: 'Waist', es: 'Cintura', fr: 'Taille' },
    anca: { pt: 'Anca', en: 'Hips', es: 'Cadera', fr: 'Hanches' }
  };
  function localName(key) {
    var clean = String(key).replace(/\s*\(.*?\)\s*/g, ' ').trim();
    var k = clean.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    for (var name in NAMES) {
      if (k.indexOf(name) === 0) return NAMES[name][LANG] || NAMES[name].pt;
    }
    return clean || key;
  }

  function buildGuide(guide, sizes, text) {
    text = text || {};
    var unit = escapeHtml(guide.unit || 'cm');
    var garment = guide.garment && guide.garment.sizes;
    var html = '';
    // one-size pieces (TU) or size names that differ from the variants: show every size in the guide
    if (garment && !sizes.some(function (s) { return lookup(garment, s); })) sizes = Object.keys(garment);

    function table(sizeMap, columns, title) {
      var rows = sizes.filter(function (size) { return lookup(sizeMap, size); });
      if (!rows.length) return '';
      var out = title ? '<h3 class="cb-size__guide-title">' + title + '</h3>' : '';
      out += '<div class="cb-size__table-wrap"><table class="cb-size__table"><thead><tr><th scope="col">' + escapeHtml(text.size || 'Tamanho') + '</th>';
      columns.forEach(function (column) {
        out += '<th scope="col">' + (column.mark ? '<span class="cb-size__mark" aria-hidden="true">' + column.mark + '</span>' : '') + escapeHtml(column.label) + '</th>';
      });
      out += '</tr></thead><tbody>';
      rows.forEach(function (size) {
        var data = lookup(sizeMap, size);
        out += '<tr><th scope="row">' + escapeHtml(size) + '</th>';
        columns.forEach(function (column) { out += '<td>' + cell(data[column.key]) + '</td>'; });
        out += '</tr>';
      });
      return out + '</tbody></table></div>';
    }

    if (garment) {
      var firstSize = sizes.filter(function (s) { return lookup(garment, s); })[0];
      var first = lookup(garment, firstSize) || {};
      var keys = Object.keys(first);
      var chestColumn = guide.chest_flat || keys.filter(function (key) { return CHEST_NAMES.test(String(key).trim()); })[0] || null;
      var lengthColumn = keys.filter(function (key) { return LENGTH_KEYS.indexOf(norm(key)) !== -1; })[0] || null;
      var columns = keys.map(function (key) {
        // Short header ("Cava (axila a axila)" -> "Cava"); the legend above explains how it is measured
        var label = localName(key);
        return { key: key, label: label, mark: key === chestColumn ? 'A' : key === lengthColumn ? 'B' : '' };
      });

      if (chestColumn || lengthColumn) {
        html += '<div class="cb-size__measure">' + figure(!!chestColumn, !!lengthColumn) + '<ul class="cb-size__legend" role="list">';
        if (chestColumn) html += '<li><span class="cb-size__mark" aria-hidden="true">A</span><span><strong>' + escapeHtml(localName(chestColumn)) + '</strong>' + escapeHtml(text.chest || 'De axila a axila') + '</span></li>';
        if (lengthColumn) html += '<li><span class="cb-size__mark" aria-hidden="true">B</span><span><strong>' + escapeHtml(localName(lengthColumn)) + '</strong>' + escapeHtml(text.length || 'Do ombro à bainha') + '</span></li>';
        html += '</ul></div>';
      }
      html += table(garment, columns);
      html += '<p class="cb-size__guide-unit">' + escapeHtml((LANG === 'pt' && guide.garment.method) || text.method || '') + ' ' + escapeHtml(text.unit || 'Medidas em [unit].').replace('[unit]', unit) + '</p>';
    }

    if (guide.body && guide.body.sizes) {
      html += table(guide.body.sizes, [
        { key: 'height', label: (text.height || 'Altura') + ' (' + unit + ')' },
        { key: 'weight', label: (text.weight || 'Peso') + ' (kg)' }
      ], escapeHtml(text.body || 'Referência corporal'));
    }

    if (guide.note) html += '<p class="cb-size__guide-method">' + escapeHtml(guide.note) + '</p>';
    return html;
  }

  function setup(root) {
    var config = JSON.parse(root.querySelector('[data-cb-size-config]').textContent);
    var html = buildGuide(config.guide || {}, config.sizes || [], config.text);
    if (!html) {
      root.hidden = true;
      return;
    }
    root.querySelector('[data-cb-size-guide-body]').innerHTML = html;

    var dialog = root.querySelector('[data-cb-size-dialog]');
    var opener = root.querySelector('[data-cb-size-open]');

    function close() {
      if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }

    opener.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('cb-size-lock');
      root.querySelector('[data-cb-size-heading]').focus();
    });
    root.querySelector('[data-cb-size-close]').addEventListener('click', close);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('cb-size-lock');
      opener.focus();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cb-size]').forEach(function (root) {
      if (root.hasAttribute('data-cb-size-ready')) return;
      root.setAttribute('data-cb-size-ready', '');
      try {
        setup(root);
      } catch (error) {
        root.hidden = true;
      }
    });
  }

  window.CBSizeGuide = { init: init };

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
